import React, { forwardRef } from 'react';

export const ForwardedButton = forwardRef(({ children, ...props }, ref) => {
  return (
    <button ref={ref} {...props}>
      {children}
    </button>
  );
});

ForwardedButton.displayName = 'ForwardedButton';
